import {
  Box,
  chakra,
  Container,
  Stack,
  Text,
  useColorModeValue,
  VisuallyHidden,
  Image,
  Link,
  Button,
} from "@chakra-ui/react";
import {
  FaWhatsapp,
  FaAngry,
  FaSnapchatGhost,
  FaTwitter,
} from "react-icons/fa";
import { ReactNode } from "react";
import KMA from "../Img/White.png";
import KMA1 from "../Img/LOGO1.png";
import tiktok from "../Img/logotiktok.png";
import tiktok2 from "../Img/tiktok2.png";

const SocialButton = ({
  children,
  label,
  href,
}: {
  children: ReactNode;
  label: string;
  href: string;
}) => {
  return (
    <chakra.button
      bg={useColorModeValue("blackAlpha.100", "whiteAlpha.100")}
      rounded={"full"}
      w={8}
      h={8}
      cursor={"pointer"}
      as={"a"}
      href={href}
      display={"inline-flex"}
      alignItems={"center"}
      justifyContent={"center"}
      transition={"background 0.3s ease"}
      _hover={{
        bg: useColorModeValue("blackAlpha.200", "whiteAlpha.200"),
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

export default function SmallWithLogoLeft() {
  return (
    <Box backgroundColor={"#000"} height={[null,'13vh']}>
      <Container
        as={Stack}
        maxW={"6xl"}
        py={4}
        direction={{ base: "column", md: "row" }}

        justify={{ base: "center", md: "space-between" }}
        align={{ base: "center", md: "center" }}
      >
        <Stack direction={"row"} spacing={6}>
          {/* 1 */}
          <Link href={"http://www.tiktok.com/@salemsien"}>
            <Button colorScheme="gray">
              <Image
                boxSize="18px"
                objectFit="cover"
                src={tiktok}
                alt="Tiktok"
              />
            </Button>
          </Link>
          {/* 2 */}
          <Link
            href={
              "https://www.snapchat.com/add/shamrokh-tech?share_id=MDI3NUM0NjQtQjE5NC00QUUyLUFBOEEtNUY1NEZFQUE5ODkw&locale=en_US"
            }
          >
            <Button colorScheme="yellow">
              <FaSnapchatGhost />
            </Button>
          </Link>
          {/* 3 */}
          <Link
            href={
              "https://twitter.com/salemsien/status/1597673362184339456?s=46&t=8cIOCtlU67ZPHgbGgw_DiA"
            }
          >
            <Button colorScheme="twitter">
              <FaTwitter />
            </Button>
          </Link>
          {/* 4 */}
          <Link href={"https://wa.me/+966505825100"}>
            <Button colorScheme="whatsapp">
              <FaWhatsapp />
            </Button>
          </Link>
        </Stack>

        <Text> Shamrukh.com 2023 &#169; </Text>

        <Text>الرياض - حي المرسلات - ش هشام عبد الملك</Text>
      </Container>
      {/* <Container
        as={Stack}
        maxW={"6xl"}
        py={4}
        direction={{ base: "column", md: "row" }}
        spacing={4}
        justify={{ base: "center", md: "center" }}
        align={{ base: "center", md: "center" }}
      >
        <Link href="https://5aled.art/">
          <Image
            boxSize="50px"
            objectFit="cover"
            src={useColorModeValue(KMA1, KMA)}
            alt="KMA"
          />
        </Link>
      </Container> */}
    </Box>
  );
}
